package meineglasfaser.api.routes

import io.ktor.resources.Resource
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import meineglasfaser.api.InvoiceDeliveryMode

@Resource("/customer-portal")
class CustomerPortalRoutes {
    @Resource("/account")
    class Account( val parent: CustomerPortalRoutes = CustomerPortalRoutes()) {
        @Resource("/base-info")
        class BaseInfo(val parent: Account = Account())

        @Resource("/full-info")
        class FullInfo(val parent: Account = Account())

        @Resource("/request-new-verification-mail")
        class RequestNewVerificationMail(val parent: Account = Account())
    }

    @Resource("/list-orders")
    class ListOrders(val parent: CustomerPortalRoutes = CustomerPortalRoutes())

    @Resource("/update-data")
    class UpdateData(val parent: CustomerPortalRoutes = CustomerPortalRoutes()) {
        @Resource("/individual")
        class Individual(val parent: UpdateData = UpdateData()) {
            @Serializable
            data class RequestBody(
                val firstName: String,
                val lastName: String,
                val dob: LocalDate?,
            )
        }

        @Resource("/company")
        class Company(val parent: UpdateData = UpdateData()) {
            @Serializable
            data class RequestBody(
                val companyName: String,
                val companyVatNumber: String,
                val companyContactPerson: String,
            )
        }

        @Resource("/phone")
        class Phone(val parent: UpdateData = UpdateData()) {
            @Serializable
            data class RequestBody(
                val telFixedLine: String,
                val telMobile: String,
            )
        }

        @Resource("/invoicing-address")
        class InvoicingAddress(val parent: UpdateData = UpdateData())

        @Resource("/invoicing")
        class Invoicing(val parent: UpdateData = UpdateData()) {
            @Serializable
            data class RequestBody(
                val invoicingEmail: String,
                val invoicingDeliveryMode: InvoiceDeliveryMode,
                val invoicingAccountHolder: String,
                val invoicingIBAN: String,
            )
        }
    }
}
